import React from 'react';
import clsx from 'clsx';

import Icon from './Icon';

import styles from './Tabs.module.scss';
import { SHOW_ALL, TABS_TO_DISPLAY } from '../api/portletConfiguration';
import { useDeviceDetection } from '../utils/DeviceDetection';
import Button, { ButtonStyles } from './Button';
import SlidingPanel from './SlidingPanel';
import FilterSetting from './FilterSetting';
import { useTCLog } from '../utils/TCEvent';
import { useDataSources } from '../api/dataSources';

export default function Tabs({ searchFor, onSearchForChange, rankedSearch }) {
	const [DATA_SRCS] = useDataSources();
	const [TCLog, setTCAppData] = useTCLog();
	const [showTabsPanel, setShowTabsPanel] = React.useState(false);
	const isMobile = useDeviceDetection();

	function handleMobileSearchForChange(newSearchFor) {
		onSearchForChange(newSearchFor);
		setShowTabsPanel(false);
	}

	return (isMobile || !(SHOW_ALL || rankedSearch)) ? (
		!isMobile ? (
			<div className={styles.root}>
				{DATA_SRCS.map((tab) => {
					return TABS_TO_DISPLAY.includes(tab.key) ? (
						<button
							key={tab.key}
							className={clsx(
								styles.tab,
								tab.key == searchFor && styles.active
							)}
							onClick={() => {
								TCLog(tab.tcEventName);
								onSearchForChange(tab.key);
							}}
						>
							<Icon
								className={styles.icon}
								icon={tab.icon}
								size="large"
								textOn="right"
							/>
							{tab.label}
						</button>
					) : null;
				})}
			</div>
		) : (
			<div className={styles.root}>
				<h4 className={styles.title}>
					<Icon icon="pin/pin_subagenzie.png" textOn="right" />
					TROVA:{' '}
					<span className={styles.searchForLabel}>{searchFor}</span>
					<Button
						className={styles.floatRight}
						variant={ButtonStyles.GHOST}
						icon={<Icon icon="icon/chevron_down_white.png" />}
						onClick={() => setShowTabsPanel(true)}
					/>
				</h4>
				{isMobile ? (
					<SlidingPanel
						show={showTabsPanel}
						onClose={() => setShowTabsPanel(false)}
					>
						<div>
							<h4 className={styles.title}>
								AXA È SEMPRE VICINO A TE
							</h4>
							<p className={styles.panelSummary}>
								Scopri tutti i servizi AXA a tua disposizione.
							</p>
							<div className={styles.panelContent}>
								{DATA_SRCS.map((tab) => {
									return TABS_TO_DISPLAY.includes(tab.key) ? (
										<FilterSetting
											className={styles.filter}
											checked={tab.key == searchFor}
											text={tab.label}
											icon={
												<Icon
													className={
														styles.filterIcon
													}
													icon="pin/pin_subagenzie.png"
													size="small"
													textOn="right"
												/>
											}
											onClick={() =>
												handleMobileSearchForChange(
													tab.key
												)
											}
											key={tab.key}
										/>
									) : null;
								})}
							</div>
						</div>
					</SlidingPanel>
				) : null}
			</div>
		)
	) : null;
}
